import { useSession } from '../dal';

export function useClientPortal(): { showClientPortal: boolean } {
  const { session } = useSession();

  return { showClientPortal: !!session?.client };
}
